import { render, staticRenderFns } from "./fifthCard.vue?vue&type=template&id=ee85c93e&"
import script from "./fifthCard.vue?vue&type=script&lang=js&"
export * from "./fifthCard.vue?vue&type=script&lang=js&"
import style0 from "./fifthCard.vue?vue&type=style&index=0&id=ee85c93e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports